import React, {useContext} from 'react';
import _ from 'lodash';

import AppStateContext from "../../../context/appStateContext";
import JobCard from '../jobCard'

import IReactiveJob from '../../../interfaces/reactiveJob';
import PlannedJob from "../../../interfaces/plannedJob";
import Asset from '../../../interfaces/asset';
import AssetsCard from "../assetsCard";
import PlannedJobCard from "../plannedJobCard";

interface ServiceProps {
  page?: string;
  itemList: IReactiveJob[] | PlannedJob[] | Asset[];
  type: string;
  clickControl: () => {},
}

const JobsList: React.FC<ServiceProps> = ({ page, itemList, type, clickControl }): React.ReactElement => {
  const { contractList, selectedCustomerId } = useContext(AppStateContext);
  let filteredContractList = _.isArray(contractList[selectedCustomerId])? contractList[selectedCustomerId]: Object.keys(contractList[selectedCustomerId]);

  const cardsArray = itemList.map((listItem: IReactiveJob | PlannedJob | Asset) => {
    if(filteredContractList.includes(listItem.ContractNo)) {
      if(type == 'reactive') {
        return (<JobCard key={listItem.CallNo} jobDetails={listItem} page={page} clickControl={clickControl}/>)
      } else if( type == 'planned') {
        return (<PlannedJobCard key={listItem.PMCallNo} jobDetails={listItem} page={page} clickControl={clickControl}/>)
      } else if (type == 'asset' && listItem.SerialNo != "") {
        return (<AssetsCard key={listItem.SerialNo} assetDetails={listItem} location={page} clickControl={clickControl}/>)
      }
    }
  });

  return <React.Fragment>{cardsArray}</React.Fragment>;
};

export default JobsList;
